import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import getFetchIdentityUserAddressOptions from './get-options';
import useFetchIdentity from "../../../web-shell-client/use-query";
var useFetchIdentityUserAddress = function useFetchIdentityUserAddress() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      enabled: true
    },
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    select = _ref.select;
  var _useFetchIdentity = useFetchIdentity(),
    isLoggedIn = _useFetchIdentity.data.isLoggedIn;
  return useQuery(_objectSpread(_objectSpread(_objectSpread({}, getFetchIdentityUserAddressOptions()), {}, {
    enabled: Boolean(isLoggedIn) && Boolean(enabled),
    staleTime: Infinity
  }, select && {
    select: select
  }), {}, {
    placeholderData: {}
  }));
};
export default useFetchIdentityUserAddress;